import { sellersListingApi } from '@apis/cp/sellers.js';
import { Toast } from '@common-web';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorString } from '@utils/utils';

const initialState = {
  stores: [],
  pagination: null,
  loading: false,
};

export const fetchSellersListing = createAsyncThunk('sellers/listing', async (params = '') => {
  try {
    return await sellersListingApi(params);
  } catch (err) {
    Toast.error(getErrorString(err));
    return [];
  }
});

const SellersSlice = createSlice({
  name: 'sellers',
  initialState,
  reducers: {
    updateSellers: (state, action) => {
      if (action?.payload?.id) {
        const index = state?.stores?.findIndex((store) => store?.id === action?.payload?.id);
        if (index !== -1) {
          state.stores[index] = { ...state?.stores?.[index], ...action?.payload };
        }
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSellersListing.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchSellersListing.fulfilled, (state, action) => {
        state.stores = action.payload.stores;
        state.statuses_and_dispositions = action.payload.statuses_and_dispositions;
        state.pagination = action.payload.pagination;
        state.healthTiers = action.payload.health_tiers;
        state.loading = false;
      });
  },
});

export const { updateSellers } = SellersSlice.actions;
export default SellersSlice.reducer;
